<!--
 * @Author:
 * @Description: 分片上传
-->
<template>
  <div>
    <div class="new-uploadFile">
      <!-- zip文件不支持多选上传 -->
      <el-upload
        class="upload-demo mt-20px"
        :auto-upload="false"
        action=""
        :on-remove="handleRemove"
        :file-list="fileList"
        :on-change="changeFile"
        :multiple="type !== 1"
        drag
      >
        <i class="el-icon-upload" style="font-size: 67px"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div v-if="type === 1" class="el-upload__tip" slot="tip">只能上传zip文件</div>
        <div slot="file" slot-scope="{ file }">
          <div>
            <span>{{ file.name }}</span>
            <span v-if="file.msg" class="ml-10px">{{ file.msg }}</span>
            <el-progress :percentage="file.percent" :stroke-width="8" :text-inside="false" />
          </div>
          <span class="el-upload-list_item-actions">
            <span class="el-upload-list_item-delete" @click="handleRemove(file, fileList)">
              <i class="el-icon-close"></i>
            </span>
          </span>
        </div>
      </el-upload>
    </div>
    <div class="pt-20px text-center">
      <template v-if="!isParseModel">
        <el-button @click="deleteAll" size="small">清空</el-button>
        <el-button type="primary" @click="uploadConfirm" size="small" :loading="uploadLoading"
          >确认上传</el-button
        >
      </template>
      <el-button @click="$emit('uploadSuccess', true)" size="small" v-else>关闭</el-button>
    </div>
    <model-view
      v-if="showModelView"
      ref="modelView"
      class="bg-white absolute left-999px top-999px"
      playerEngineId="splitEngineId"
      :cloudRender="cloudRender"
      :modelProps="modelProps"
      :showDocComponent="false"
      :modelParams="modelParams"
      :modelName="modelName"
      :basicTabBar="[]"
      :businessTabBar="[]"
      @sendPlayer="($event) => (mainPlayer = $event)"
      @LoadedAllModel="loadedAllModel"
      @loadError="loadError"
    ></model-view>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import documentManagementService from '@/services/documentManagement'
import DocumentService from '@/services/DocumentService'
import fnMixin from '@/assets/js/fnMixins'
import * as XLSX from 'xlsx'
import { instance as cloudRender } from 'wiz-cloud-render-vulkan'
import ModelServer from '../../model-file-management/services/modelServer'

const ModelView = () => {
  return import('@/modules/resource/components/model/ModelViewVk')
}
export default {
  name: 'newUploadFile',
  mixins: [fnMixin],
  components: {
    ModelView,
  },
  props: {
    initFiles: {
      type: Array,
      default() {
        return []
      },
    },
    type: {
      type: Number,
    },
    uploadValid: {
      type: Function,
      default() {
        return {}
      },
    },
    standardId: {
      type: String,
      default: '',
    },
    uploadForm: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      fileList: [],
      accept: ['zip'],
      uploadLoading: false,
      sliceSize: 5 * 1024 * 1024,
      batchKey: '',
      mergeCount: 0,
      modelType: ['pr', 'pprj', 'rvm', 'fbx', 'vue'],
      parseQueue: [],
      showModelView: false,
      modelParams: [],
      modelProps: {},
      modelName: '',
      isParseModel: false,
    }
  },
  computed: {
    cloudRender() {
      return cloudRender
    },
  },
  watch: {
    initFiles() {
      this.fileList = []
      this.isParseModel = false
    },
  },
  methods: {
    // 移除文件
    handleRemove(file, fileList) {
      this.fileList = fileList.filter((item) => {
        return item.uid !== file.uid
      })
    },
    changeFile(file, fileList) {
      // 检查文件类型
      const name = file.name
      const fileSuffix = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      if (
        !this.accept
          .map((i) => {
            return i.toLowerCase()
          })
          .includes(fileSuffix) &&
        this.type === 1
      ) {
        this.$message.warning(`上传文件只能是${this.accept.join('、')}`)
        this.fileList = []
        return false
      }

      // 检查文件名重复
      const currentIndex = fileList.findIndex((item) => {
        return item.uid === file.uid
      })
      const duplicateFiles = fileList.filter((item, index) => {
        // 只检查当前文件之前的文件是否重名
        return index < currentIndex && item.name === file.name
      })

      if (duplicateFiles.length > 0) {
        this.$message.warning(`文件"${file.name}"已存在，请勿重复上传`)
        // 从文件列表中移除当前文件
        this.fileList = fileList.filter((item) => {
          return item.uid !== file.uid
        })
        return false
      }

      this.fileList = fileList
      console.log(this.fileList, 'fileList')
      return true
    },
    deleteAll() {
      this.fileList = []
    },
    // 确认上传
    async uploadConfirm() {
      // 验证通过
      if (this.uploadValid()) {
        if (!this.fileList.length) {
          this.$message.warning('请选择文件')
          return
        }
        this.mergeCount = 0
        this.batchKey = new Date().getTime().toString()
        this.uploadLoading = true

        /* eslint-disable no-await-in-loop */
        // 顺序上传文件
        for (let i = 0; i < this.fileList.length; i += 1) {
          try {
            await this.customUpload(this.fileList[i])
          } catch (error) {
            console.error('文件上传失败:', error)
            this.uploadLoading = false
            break
          }
        }
      }
    },
    // 分片上传
    customUpload(file) {
      return new Promise((resolve, reject) => {
        console.log(file, 'file')
        let uploadId = ''
        // 初始化进度为0
        this.$set(file, 'percent', 0)
        this.$set(file, 'msg', '上传中')
        this.calculateMD5(file.raw, this.sliceSize)
          .then(async (md5) => {
            try {
              const blob = file.raw
              const partETags = []
              // eslint-disable-next-line no-unused-vars
              const { size: fileSize, name: fileName } = blob
              const totalSlice = Math.ceil(fileSize / this.sliceSize)
              this.chunktotle = totalSlice

              // 第一步 获取uploadId
              if (!uploadId) {
                const formData = new FormData()
                formData.append('objectKey', md5.toUpperCase())
                formData.append('batchKey', this.batchKey)
                const res = await documentManagementService.chunkUpload(formData)
                if (res && res.code === 0) {
                  uploadId = res.data.uploadId || ''
                }
              }

              /* eslint-disable no-await-in-loop */
              // 第二步 循环上传切片
              for (let i = 0; i < totalSlice; i += 1) {
                await this.$nextTick()
                const progress = Math.floor(((i + 1) / totalSlice) * 100)
                this.$set(file, 'percent', progress)

                const start = i * this.sliceSize
                const chunk = blob.slice(start, Math.min(fileSize, start + this.sliceSize))

                const formData = new FormData()
                formData.append('objectKey', md5.toUpperCase())
                formData.append('batchKey', this.batchKey)
                formData.append('file', chunk)
                formData.append('partNumber', i + 1)
                formData.append('uploadId', uploadId)

                const resChunk = await documentManagementService.chunkUpload(formData)
                if (resChunk && resChunk.code === 0) {
                  partETags.push({
                    partNumber: resChunk.data.partNumber,
                    eTag: resChunk.data.eTag,
                  })

                  if (i + 1 === totalSlice) {
                    await this.chunksMerge(uploadId, md5, partETags, file)
                    resolve() // 合并完成后才进行下一个文件
                  }
                } else {
                  throw new Error('切片上传失败')
                }
              }
              /* eslint-enable no-await-in-loop */
            } catch (error) {
              reject(error)
            }
          })
          .catch((error) => {
            this.$set(file, 'percent', 0)
            this.$set(file, 'msg', '上传失败')
            this.$message.error(error.message || '上传失败')
            this.uploadLoading = false
            reject(error)
          })
      })
    },
    // 合并分片
    async chunksMerge(uploadId, md5, partETags, file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.'))
      // 先增加合并次数
      this.mergeCount += 1
      // 传参
      const params = {
        uploadId,
        objectKey: md5.toUpperCase(),
        folderId: this.uploadForm.FolderId,
        standardId: this.standardId,
        isAddDocument: this.uploadForm.isAddDocument,
        classId: this.uploadForm.classId,
        fileName: file.name,
        md5: md5.toUpperCase(),
        batchKey: this.batchKey,
        fileSize: file.size,
        fileType,
        partETags,
        allCompleted: this.mergeCount === this.fileList.length, // 判断是否是最后一个文件的合并请求
        FileRegularExpressions: this.uploadForm.FileRegularExpressions,
      }
      try {
        const res = await documentManagementService.chunkUploadCompleteV2(params)
        if (res && res.code !== 1) {
          this.$set(file, 'percent', 100)
          this.$set(file, 'msg', '上传成功')
          if (this.mergeCount === this.fileList.length) {
            const headers = [
              'DocumentId',
              'DocumentFileId',
              'FileId',
              '上传文件',
              '上传结果',
              '提示信息',
            ]
            const result = [headers]
            this.parseQueue = []
            res.data.forEach((item) => {
              const type = item.file
                .split('.')
                .at(-1)
                .toLowerCase()
              if (this.modelType.includes(type) && item.fileId) {
                const fileObj = _.find(this.fileList, { name: item.file })
                this.$set(fileObj, 'msg', '等待中')
                this.$set(fileObj, 'percent', 0)
                this.parseQueue.push({
                  fileId: item.fileId,
                  fileUid: fileObj.uid,
                })
              }
              result.push([
                item.documentId,
                item.documentFileId,
                item.fileId,
                item.file,
                item.result,
                item.message,
              ])
            })
            const workbook = XLSX.utils.book_new()
            const worksheet = XLSX.utils.aoa_to_sheet(result)
            XLSX.utils.book_append_sheet(workbook, worksheet, '文档上传结果')
            XLSX.writeFile(workbook, '文件导入明细.xlsx')
            if (this.parseQueue.length) {
              this.isParseModel = true
              this.parseModelTag()
            } else {
              this.$message.success('上传成功')
              this.$emit('uploadSuccess', true)
            }
          }
        }
      } catch (error) {
        this.$message.error(error.message || '合并失败')
        this.$set(file, 'percent', 0)
        this.$set(file, 'msg', '合并失败')
      } finally {
        // 最后一个文件处理完成后，重置状态
        if (this.mergeCount === this.fileList.length) {
          this.uploadLoading = false
          this.mergeCount = 0
        }
      }
    },
    // md5 的计算
    calculateMD5(file, chunkSize) {
      return new Promise((resolve, reject) => {
        const chunks = Math.ceil(file.size / chunkSize)
        const spark = new SparkMD5.ArrayBuffer()
        const fileReader = new FileReader()
        let currentChunk = 0

        fileReader.onload = (e) => {
          spark.append(e.target.result) // 更新 MD5 值
          currentChunk += 1
          if (currentChunk < chunks) {
            this.loadNextChunk(fileReader, currentChunk, chunkSize, file)
          } else {
            const md5 = spark.end() // 计算最终 MD5 值
            resolve(md5)
          }
        }
        // eslint-disable-next-line func-names
        fileReader.onerror = function(e) {
          reject(e)
        }
        this.loadNextChunk(fileReader, currentChunk, chunkSize, file)
      })
    },
    // md5 计算
    loadNextChunk(fileReader, currentChunk, chunkSize, file) {
      const start = currentChunk * chunkSize
      const end = Math.min(start + chunkSize, file.size)
      const chunk = file.slice(start, end)
      fileReader.readAsArrayBuffer(chunk)
    },
    async parseModelTag() {
      if (this.parseQueue.length === 0) {
        this.showModelView = false
        this.modelParams = []
        this.modelProps = {}
        this.modelName = ''
        return
      }
      const data = this.parseQueue.shift()
      const fileRes = await DocumentService.getDocumentFileType({
        standardId: this.standardId,
        fileId: data.fileId,
      })
      const file = _.find(this.fileList, { uid: data.fileUid })
      this.currentParseFileUid = data.fileUid
      this.$set(file, 'msg', '模型对象获取中（请不要关闭）')
      this.$set(file, 'percent', 0)
      if (fileRes?.code === 0) {
        const name = fileRes.data.fileNameOrigin || fileRes.data.fileName
        const modelType = name
          .split('.')
          .at(-1)
          .toLowerCase()
        this.modelParams = [
          {
            ..._.pick(fileRes.data, ['fileId', 'documentId']),
            name,
            type: modelType,
            md5: fileRes.data.fileOriginMd5,
          },
        ]
        this.modelProps = {
          defaultModelId: fileRes.data.documentId,
        }
        this.modelName = fileRes.data.documentId
        this.showModelView = true
      }
    },
    async loadedAllModel() {
      const root = await this.mainPlayer.Native.Node.getRoot()
      const children = await this.mainPlayer.Native.Node.collectChildren(root)
      const childrenInfo = await this.mainPlayer.Native.Node.getProperty(children, ['code'])
      const tags = []
      _.forEach(childrenInfo, (item) => {
        if (item.code) {
          tags.push(item.code)
        }
      })
      const res = await ModelServer.analysisModelTag({
        standardId: this.standardId,
        documentId: this.modelName,
        tags,
      })
      const file = _.find(this.fileList, { uid: this.currentParseFileUid })
      if (res && res.code === 0) {
        this.$set(file, 'msg', '解析中')
        this.getParseProgress({
          file,
          progressKey: res.details.progressKey,
        })
      } else {
        this.$set(file, 'msg', '解析失败')
      }
      this.parseModelTag()
    },
    async getParseProgress(data) {
      const res = await documentManagementService.getDocumentBatchRelationProgress(data.progressKey)
      if (res) {
        this.$set(data.file, 'percent', res.currentProgress)
        if (res.hasError) {
          this.$set(data.file, 'msg', res.status)
        } else if (res.isCompleted) {
          this.$set(data.file, 'msg', '解析完成')
        } else if (res.currentProgress !== 100) {
          setTimeout(() => {
            this.getParseProgress(data)
          }, 1500)
        }
      }
    },
    loadError() {
      this.parseQueue = []
      this.showModelView = false
      this.modelParams = []
      this.modelProps = {}
      this.modelName = ''
    },
  },
}
</script>

<style lang="scss" scoped>

.new-uploadFile {
  border: 2px dashed rgb(197, 196, 196);
  display: flex;
  justify-content: center;
  height: 360px;
  overflow-y: auto;
  /deep/.el-upload-dragger {
    height: 200px !important;
  }
}

</style>
